import { render, staticRenderFns } from "./infiniteScroll.vue?vue&type=template&id=31048c38"
import script from "./infiniteScroll.vue?vue&type=script&lang=js"
export * from "./infiniteScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports